// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1HebF","col":"styles_col__3o0DW","fulfillmentStatus":"styles_fulfillmentStatus__1m5zt","emailCol":"styles_emailCol__1rYjU"};